module.exports = __webpack_public_path__ + "img/12.38d95bbd.webp";